import React, { Component } from 'react';
import { withSize, SizeMe } from 'react-sizeme'
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import { Button } from 'react-bootstrap';
import moment from 'moment';
// import _default from 'antd/lib/date-picker';

class Payment extends Component 
{
  constructor(props){
    super(props);
    
    this.state={
      show_spinner:true,
      no_data:false, //如果拉不到資料設為true
      message:null,
      payment_list:[],
      data:{},
      current_idx:0,   // 目前頁面
      current_item:{}, // 目前頁面的資料
      items:[],
      last_payment:{},
    }

  }

  componentDidMount(){
    this.pullData()
  }

  showPage(idx = 0){
    const { payment_list = []}= this.state;
    console.log('showPage', idx, payment_list.length, payment_list)
    console.log('showPage', idx + 1 <= payment_list.length, idx >= payment_list.length)

    if (idx < 0 || idx >= payment_list.length)
    {
      idx = 0
    }

    let data = payment_list[idx] || {}

    const {items = []} = data

    console.log(data, items)

    this.setState({
      //message: items.length === 0 && "尚無管理費繳交資訊，請洽物管",
      no_data: items.length === 0,
      data:data,
      current_idx: idx,
      items: items
    })
  }
  pullData(){
    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.4/payment', 
      { }, 
      (state, res) => {

        console.log('api/v1.4/payment', state, res)

        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }
        
        http.post(
          CONFIG.API_HOST + 'api/v1.4/payment/read', 
          { }, 
          (state, res) => {
            
            if (state === false) { return console.error('發生錯誤'); }
    
            if (res.code !== 200) { return console.error(res.reason, res); }
        })

        const { payment_list = [], last_payment={}}= res.data;
        
        this.setState({
          payment_list:payment_list,
          last_payment:last_payment,
        },() => { 
            
            const targetPaymentInfo = payment_list.find(item => item.year == moment().year())

            console.log('targetPaymentInfo', moment().year(), targetPaymentInfo)
            let idx = payment_list.indexOf(targetPaymentInfo)
            
            this.showPage(idx !== -1 ? idx : 0)
        })
        console.log(this.state.items);
      }
    )
  }

  render()
  {
    const { data={}, current_idx=0, payment_list=[] } = this.state
    const { items = [] } = data
    const { width, height } = this.props.size
    var { last_payment = {} } = this.state

    last_payment = last_payment || {}

    console.log('render', current_idx)
    
    const div_button = <div>
          { current_idx > 0 && 
            <Button bsStyle="primary"
              className={[styles.nav_btn, styles.prev_btn].join(' ')}
              onClick={ (e) => { console.log('kkk'); this.showPage(this.state.current_idx - 1) }}
            />
          }
          { current_idx + 1 < payment_list.length && 
            <Button
              bsStyle="primary"
              className={[styles.nav_btn, styles.back_btn].join(' ')}
              onClick={ (e) => { console.log('b'); this.showPage(this.state.current_idx + 1) }}
            />
          }
        </div>;
    return (
      <div className={styles.page_container} >
        { (this.state.no_data || this.state.message) ? 
          <div>
            <WMask  title={ this.state.message ? this.state.message : ''}>
              { this.state.no_data &&
                <div>
                  <h1>目前暫無資料，請洽物管</h1><p>如貴社區未使用社區雲<br/>煩請管委會與我們聯繫</p>
                </div>
              }
            </WMask>
            {div_button}
          </div>
          :
          <div>{div_button}</div>
        }

        
        { data.name &&
          <div className={styles.list_title}>{data.name}</div>
        }
        
        
        <div className={(last_payment != null && last_payment.id != null) ? [styles.item_container, styles.padding].join(' ') : styles.item_container}
          style={{paddingBottom:this.state.paddingBottom||100}}
        >{data.status_name}
          {
            items.map((item, index) =>
              <div  className={ styles.list_item }>
                <div className={styles.title}> {item.name} </div>
                
                <div className={styles.content}>
                  <div className={item.status === 'Y' ? styles.text:styles.comment}>
                    <span>{item.status_name}</span>
                  </div>
                </div>
              </div>
            )
          }
        </div>
        { last_payment.id != null && 
          <SizeMe 
            monitorHeight
            refreshRate={32}
            render={({ size }) => {
              if (size.height != this.state.paddingBottom) {
                this.setState({ paddingBottom: size.height})
              }
              return (
              <div className={styles.info_list}>
                  <ul>
                    <li style={{color:'#006FBC'}} >最新繳款資訊</li>
                    <li>繳費期限：{last_payment.exp_date}</li>
                    <li>繳費日期：{last_payment.due_date}</li>
                    {
                      last_payment.detail_list && last_payment.detail_list.map( (detail,idx) =>
                        <li key={idx}>{detail.name}：{detail.money}</li>
                      )
                    }
                    <li>實收：{last_payment.amt}</li>
                  </ul>
              </div>
            )}}
          />
        }
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }

      </div>
    );
  }
}

export default withSize({ monitorHeight:true})(Payment);


// WEBPACK FOOTER //
// ./src/views/Payment/Payment.js